import { FileHistory } from '../../../components/main/options/model/edit/ListFiles'
import { BASE_SERVICE_URL, STATUS_CACHE_PREVIEW } from '../../../lib/constants'
import { getUser } from '../../helper/getUser'
import newGet from '../../methods/get'

export default async function getFiles(collection: string): Promise<FileHistory[]> {
    try {
        const getApi = await newGet(`${collection}/files`)
        const data = (await getApi.json()) as FileHistory[]
        return data
    } catch (error) {
        console.error(error)
        return []
    }
}

export async function getUserFiles(): Promise<FileHistory[]> {
    try {
        const getApi = await newGet(`user/${getUser()}/files`)
        const data = (await getApi.json()) as FileHistory[]
        return data
    } catch (error) {
        console.error(error)
        return []
    }
}

async function getHistoryPreview(file: FileHistory, dateReference?: boolean): Promise<any> {
    try {
        const postApi = await fetch(BASE_SERVICE_URL + `/history/preview`, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mountData(file, dateReference))
        })

        if (postApi.status === 307) {
            const cacheId = await postApi.text()

            const cacheStatus = {
                status: STATUS_CACHE_PREVIEW.PROCESSING
            }

            while (cacheStatus.status === STATUS_CACHE_PREVIEW.PROCESSING) {
                await new Promise(r => setTimeout(r, 2000))
                const newStatus = await cacheStatusHistoryPreview(cacheId)
                cacheStatus.status = newStatus.status
            }
            if (cacheStatus.status == STATUS_CACHE_PREVIEW.OK) {
                return getHistoryPreview(file, dateReference)
            }
        } else if (postApi.status == 200) return postApi.json()
        //TODO: FIX CASE ERROR
        return null
    } catch (e) {
        console.error(e)
        return {}
    }
}

async function cacheStatusHistoryPreview(id: string): Promise<{ status: string }> {
    return await (await newGet(`history/preview/cache/${id}`)).json()
}

function mountData(file: FileHistory, dateReference?: boolean): any {
    return {
        enabled: true,
        username: getUser(),
        eventType: file.collection,
        collection: file.collection,
        sheetIndex: file.sheetIndex,
        uid: file.uid,
        fileName: file.fileName,
        dateReference
    }
}
export { getHistoryPreview }
